import { useState, useEffect, useCallback } from 'react';

export interface Country {
  id: string;
  label: string;
}

/**
 * Hook for filtering countries by search term
 */
export function useCountryListFilter(countryList: Country[]) {
  const [filteredList, setFilteredList] = useState<Country[]>(countryList);
  const [filter, setFilterState] = useState('');

  useEffect(() => {
    setFilteredList(countryList);
    setFilterState('');
  }, [countryList]);

  const setFilter = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setFilterState(value);
      
      if (value.trim() === '') {
        setFilteredList(countryList);
      } else {
        const searchTerm = value.toLowerCase();
        const filtered = countryList.filter(({ label, id }) =>
          label.toLowerCase().includes(searchTerm) ||
          id.toLowerCase().includes(searchTerm)
        );
        setFilteredList(filtered);
      }
    },
    [countryList]
  );

  return { filter, setFilter, filteredList };
}

